var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "led",
            "title": "솔루션",
            "src": "/images/sub/subvisual-solution.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    scopedSlots: _vm._u([{
      key: "titleLine",
      fn: function fn() {
        return [_vm._v(" 식물공장 시설 ")];
      },
      proxy: true
    }])
  }, [_c('tit-wrap-large', {
    staticClass: "mb-0",
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm._v(" 에너지 절약과 동시에 광범위한 파장과 스펙트럼으로 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("작물의 성장 단계에 따라 LED를 조절하여 효율적인 농업이 가능합니다. ")];
      },
      proxy: true
    }])
  }, [_vm._v(" 태양광을 대체하는 인공 고효율 스마트제어 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _c('b', [_vm._v("LED 조명 시스템")])])], 1), _c('page-section', {
    staticClass: "page-section--last grey lighten-5"
  }, [_c('page-section', {
    staticClass: "page-section--sm py-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          staticClass: "mx-n20px my-n10px mx-md-n30px my-md-n20px"
        }, [_c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-left",
            "data-aos-delay": "200"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": "570",
            "aspect-ratio": 570 / 456,
            "src": "/images/sub/solution/plant/led-img.jpg"
          }
        })], 1)], 1), _c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-right",
            "data-aos-delay": "200"
          }
        }, [_c('div', {
          staticClass: "mt-md-24px"
        }, [_c('tit-wrap-sprout', [_vm._v(" LED 조명시스템 ")]), _c('txt-item', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("LED 특성")];
            },
            proxy: true
          }])
        }, [_vm._v(" 광도, 광량, 채도 등 빛을 효율적으로 제어 관리하여 작물의 생장에 알맞은 빛을 공급함으로써 작물의 생장 기간 및 발육 상태를 조절할 수 있습니다. ")]), _c('div', {
          staticClass: "mt-16px mt-md-24px"
        }, [_c('v-card', {
          staticClass: "rounded-tl-xl rounded-br-xl d-inline-block",
          attrs: {
            "outlined": "",
            "tile": ""
          }
        }, [_c('v-img', {
          attrs: {
            "width": "126",
            "aspect-ratio": 126 / 102,
            "src": "/images/sub/solution/plant/led-img2.jpg"
          }
        })], 1)], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-card', {
          staticClass: "d-flex align-center justify-center",
          attrs: {
            "outlined": "",
            "rounded": "",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('div', {
          staticClass: "w-100 py-sm-20px py-lg-40px py-xl-100px"
        }, [_c('v-row', {
          attrs: {
            "no-gutters": "",
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "lg": "auto"
          }
        }, [_c('div', {
          staticClass: "px-12px py-30px px-md-20px px-xl-60px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "width": _vm.$vuetify.breakpoint.lgAndUp ? 482 : '100%',
            "aspect-ratio": 482 / 494,
            "src": "/images/sub/solution/plant/led-img3.png"
          }
        }), _c('div', {
          staticClass: "mt-14px mt-md-20px text-center"
        }, [_c('p', {
          staticClass: "txt txt--lg txt--dark"
        }, [_vm._v("스마트 관제 시스템을 통해 원격 모니터링 및 제어가 가능해 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("작물 재배의 편의성과 효율성이 높습니다.")])])], 1)]), _c('v-col', {
          staticClass: "d-none d-lg-block align-self-stretch ml-n1px",
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-divider', {
          staticClass: "h-100",
          attrs: {
            "vertical": ""
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "lg": "auto"
          }
        }, [_c('div', {
          staticClass: "px-12px py-20px px-md-20px px-xl-60px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "width": _vm.$vuetify.breakpoint.lgAndUp ? 354 : '100%',
            "aspect-ratio": 354 / 444,
            "src": "/images/sub/solution/plant/led-img4.png"
          }
        })], 1)])], 1)], 1)])];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          attrs: {
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "382",
            "aspect-ratio": 382 / 540,
            "src": "/images/sub/solution/plant/led-img5.jpg"
          }
        })], 1), _c('tit-wrap-small', {
          staticClass: "mt-14px mt-md-20px",
          attrs: {
            "mbSmall": ""
          },
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" 식물재배용 조명장치 ")];
            },
            proxy: true
          }])
        }, [_vm._v(" 특허등록 ")])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }